import React from 'react';

import classNames from 'classnames';

import styles from './InputWarning.module.css';

export enum InputWarningColor {
  dark = 'var(--midnight-purple)',
  darkBlue = 'var(--dark-warning-blue)',
  freezeOrder = 'var(--freeze-order-error-red)',
  lightRuby = 'var(--light-ruby)',
  pink = 'var(--classic-rose)',
  primary = 'var(--error-red)',
  ruby = 'var(--ruby)',
  secondary = 'var(--primary-border-color)',
  warning = 'var(--custom-paypal-warning-color)',
}

export type Props = {
  className?: string;
  color?: InputWarningColor;
  height?: number;
  onClick?(): void;
  reversedExclamationMark?: boolean;
  width?: number;
};

export const InputWarning = React.memo((props: Props) => {
  const {
    width = 16,
    height = 16,
    className,
    reversedExclamationMark,
    color = InputWarningColor.primary,
    onClick,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      className={classNames(
        { [styles.reversedExclamationMark]: reversedExclamationMark },
        className,
      )}
      style={{
        minWidth: width,
        minHeight: height,
      }}
      onClick={onClick}
      viewBox='0 0 16 16'
      fill='none'
    >
      <g fill='none'>
        <circle
          cx='8'
          cy='8'
          r='7'
          stroke={color}
          strokeWidth='2'
        />

        <line
          x1='8'
          y1='5'
          x2='8'
          y2='8'
          stroke={color}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />

        <circle
          cx='8'
          cy='11'
          r='1'
          fill={color}
        />
      </g>
    </svg>
  );
});

InputWarning.displayName = 'InputWarning';
